<template>
    <div class="thankYou-page">
        <div class="thankYou-pageContent">
            <div class="text-center">
                <h1 class="display-4 mb-4">Download Report</h1>
                <p class="lead txt--l txt--off-white">
                    Your exported data is ready to be downloaded.
                </p>
                <a :href="download_link" download class="button button--primary button--sm mr-3 mt-3" v-if="download_link!=''">Download Report</a>
                <hr class="border--bottom-gray border-top-0" />
                <p class="txt--ss">
                    Having trouble?
                    <a class="txt--primary" href="mailto:hello@piedparker.com?subject=Hello!">Contact us</a>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            export_id: '',
            download_link: '',
        }
    },
    created() {
        let access_token = localStorage.getItem("commercial_token_new");
        
        this.export_id = this.$route.params.id;

        if(access_token ==null || access_token == '') {
            this.$router.push(`/login?export_id=${this.export_id}`);
        }
        else {
            this.getExportLink();
        }
    },
    methods: {
        getExportLink() {
            this.axios.post(window.hostname+'api/auth/reports/exported-zip-link',{
                export_id: this.export_id
            })
            .then(res=> {
                if(res.data.status) {
                    this.download_link = res.data.data;
                    // let file_name = res.data.data.file_name ;
                    var element = document.createElement("a");
                    element.href = this.download_link;
                    element.setAttribute("download", "Reports.xlsx");

                    element.style.display = "none";
                    document.body.appendChild(element);

                    element.click();

                    document.body.removeChild(element);
                    this.$toasted.show("Your file download has started!", {
                    icon: "check-circle",
                    className: "success-class",
                    });
                }
                else {
                    this.$toasted.show(res.data.message,{
                        icon: 'times-circle',
                        className: 'error-class'
                    });
                }
            })
            .catch(err=> {
                this.$toasted.show(err.response.data.message,{
                    icon : 'times-circle',
                    className: 'error-class'
                });
            })
        }
    }
}
</script>